/**
 * ExtReact Application bootstrap
 */

import React, {useEffect} from 'react';
import {createRoot} from 'react-dom/client';

import '../../shared/src/types/yn.d';

import App from './App';
import {
    AppDispatch,
    store
} from './store';
import {loadSession} from './actions/login';
///////////////////
///////////////////////////////////
//////////
import {GlobalDataData} from '~/shared/src/model/GlobalData';

//require( '../../shared/src/utilities/console.ts' );
require( '../../shared/src/utilities/error.ts' );
require( '../../shared/src/utilities/object.ts' );
require( '../../shared/src/utilities/string.ts' );

/* eslint-disable no-var */
declare global {
    var BASE_URL : string;
    var LP_URL : string;
    var SOCKET_URL : string;
    var webSocketId : string;
    var landingPageApp : string | undefined;
    var landingPagePanelConfig : number | undefined;
    var landingPageRequestParameters : { [ parameterKey : string ] : any } | undefined;
    var landingPageContent : string | undefined;
    var loginAfterSessionExpired : boolean;
    var directLink : string | undefined;
    var directLinkUrl : string | undefined;
}
/* eslint-disable no-var */
global.BASE_URL = HOST ? `${window.location.protocol}//${HOST}` : '';
global.LP_URL = global.landingPageApp && LP_HOST ? `${window.location.protocol}//${LP_HOST}` : '';
global.SOCKET_URL = `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${HOST ? HOST : window.location.host}`;
global.webSocketId = '';
global.loginAfterSessionExpired = false;
global.directLink = window.location.hash;
global.directLinkUrl = window.location.href;

( window as any ).global = window;
global.defaultSchema = 'DATA';
global.schema = global.defaultSchema;
global.data = {
    default: {
        items     : {},
        references: {},
        schema    : global.schema
    }
} as GlobalDataData;

global.logSeparatorWidth = 30;

// if any dirty panels, prevent window close/refresh
window.onbeforeunload = function( event ) {
    const state   = store.getState(),
          isDirty = state.panelManager?.openPanels?.some( panelConfig => panelConfig.isDirty );

    // show prompt before close/reload the browser window if anything is dirty
    if ( isDirty ) {
        event.preventDefault();
        return ( event.returnValue = '' );
    }
    else {
        return;
    }
}

if ( global.landingPageApp ) {
    window.localStorage.clear();
}


const container = document.getElementById( 'root' );
const root = createRoot( container! );


/**
 *
 * @constructor
 */
function AppWithCallbackAfterRender() : JSX.Element { // eslint-disable-line @typescript-eslint/naming-convention
    useEffect( () => {
        ( store.dispatch as AppDispatch )( loadSession() );
    } );

    return <App/>
}

root.render(
    <AppWithCallbackAfterRender/>
);
